export const FILE_FIELD = 'file'

export const getDefaultValues = () => ({
  [FILE_FIELD]: '',
})
